'use client';

import React, { FC, HTMLAttributes } from 'react';
import TableHead from './components/table-head';
import TableBody from './components/table-body';
import TableRow from './components/table-row';
import TableCell from './components/table-cell';
import TableHeaderCell from './components/table-header-cell';
// import TablePagination from './components/table-pagination';
import TableContainer from './components/table-container';
import './styles/index.css';
import { classnames } from '@/utils/classnames/classnames';

const Table: FC<HTMLAttributes<HTMLDivElement>> & {
  Container: typeof TableContainer;
  Head: typeof TableHead;
  Body: typeof TableBody;
  Row: typeof TableRow;
  Cell: typeof TableCell;
  HeaderCell: typeof TableHeaderCell;
  // Pagination: typeof TablePagination;
} = ({ className = '', ...props }) => {
  return (
    <div
      className={classnames('overflow-x-auto whitespace-pre overscroll-none', className)}
      {...props}
    />
  );
};

Table.Container = TableContainer;
Table.Head = TableHead;
Table.Body = TableBody;
Table.Row = TableRow;
Table.Cell = TableCell;
Table.HeaderCell = TableHeaderCell;
// Table.Pagination = TablePagination;

export default Table;